export const formInitialValues = {
  images: [],
};
